function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.5 8.58326C53.154 8.58326 53.6842 8.05308 53.6842 7.39905C53.6842 6.74503 53.154 6.21484 52.5 6.21484C51.846 6.21484 51.3158 6.74503 51.3158 7.39905C51.3158 8.05308 51.846 8.58326 52.5 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.702,
  d: "M59.6053 8.58326C60.2593 8.58326 60.7895 8.05308 60.7895 7.39905C60.7895 6.74503 60.2593 6.21484 59.6053 6.21484C58.9512 6.21484 58.4211 6.74503 58.4211 7.39905C58.4211 8.05308 58.9512 8.58326 59.6053 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.401,
  d: "M66.7105 8.58326C67.3645 8.58326 67.8947 8.05308 67.8947 7.39905C67.8947 6.74503 67.3645 6.21484 66.7105 6.21484C66.0565 6.21484 65.5263 6.74503 65.5263 7.39905C65.5263 8.05308 66.0565 8.58326 66.7105 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.104,
  d: "M73.8158 8.58326C74.4698 8.58326 75 8.05308 75 7.39905C75 6.74503 74.4698 6.21484 73.8158 6.21484C73.1618 6.21484 72.6316 6.74503 72.6316 7.39905C72.6316 8.05308 73.1618 8.58326 73.8158 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 8.58326C23.154 8.58326 23.6842 8.05308 23.6842 7.39905C23.6842 6.74503 23.154 6.21484 22.5 6.21484C21.846 6.21484 21.3158 6.74503 21.3158 7.39905C21.3158 8.05308 21.846 8.58326 22.5 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.702,
  d: "M15.3947 8.58326C16.0488 8.58326 16.5789 8.05308 16.5789 7.39905C16.5789 6.74503 16.0488 6.21484 15.3947 6.21484C14.7407 6.21484 14.2105 6.74503 14.2105 7.39905C14.2105 8.05308 14.7407 8.58326 15.3947 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.399,
  d: "M8.28947 8.58326C8.9435 8.58326 9.47368 8.05308 9.47368 7.39905C9.47368 6.74503 8.9435 6.21484 8.28947 6.21484C7.63545 6.21484 7.10526 6.74503 7.10526 7.39905C7.10526 8.05308 7.63545 8.58326 8.28947 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.108,
  d: "M1.18421 8.58326C1.83823 8.58326 2.36842 8.05308 2.36842 7.39905C2.36842 6.74503 1.83823 6.21484 1.18421 6.21484C0.530189 6.21484 0 6.74503 0 7.39905C0 8.05308 0.530189 8.58326 1.18421 8.58326Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M43.8497 6.41605C43.706 6.41605 43.2253 6.42 43.0903 6.42868L40.3508 6.50053C40.3365 6.50131 40.3223 6.4982 40.3096 6.49153C40.297 6.48485 40.2864 6.47486 40.2789 6.46263L36.1721 0.315789C36.1112 0.219526 36.0271 0.140137 35.9275 0.0849464C35.8279 0.0297563 35.716 0.000542451 35.6021 0L34.6018 0C34.365 0 34.286 0.236842 34.3697 0.455526L36.4847 6.48316C36.491 6.49582 36.4938 6.50995 36.4928 6.52406C36.4918 6.53817 36.487 6.55174 36.4789 6.56336C36.4708 6.57498 36.4598 6.58422 36.4469 6.59011C36.4341 6.596 36.4199 6.59832 36.4058 6.59684L31.2387 6.67579C31.1852 6.6774 31.1321 6.66637 31.0837 6.6436C31.0352 6.62082 30.9929 6.58696 30.96 6.54474L29.4008 4.64368C29.3377 4.56297 29.2569 4.49779 29.1646 4.45318C29.0724 4.40856 28.9711 4.38569 28.8687 4.38632H28.1582C28.1314 4.38646 28.1051 4.39299 28.0813 4.40536C28.0576 4.41772 28.0372 4.43557 28.0217 4.45742C28.0063 4.47927 27.9963 4.50449 27.9926 4.53098C27.9888 4.55747 27.9915 4.58447 28.0003 4.60974L28.8395 7.50947C28.9028 7.67086 28.9028 7.85019 28.8395 8.01158L27.9995 10.9121C27.9907 10.9374 27.988 10.9644 27.9918 10.9909C27.9955 11.0174 28.0055 11.0426 28.021 11.0644C28.0364 11.0863 28.0568 11.1041 28.0806 11.1165C28.1043 11.1289 28.1306 11.1354 28.1574 11.1355H28.8624C28.9647 11.1352 29.0656 11.1119 29.1577 11.0674C29.2498 11.0228 29.3307 10.9582 29.3945 10.8782L30.99 8.94868C31.0232 8.90679 31.0656 8.87316 31.1139 8.85042C31.1623 8.82768 31.2153 8.81646 31.2687 8.81763L36.4058 8.93132C36.4194 8.93118 36.4329 8.93439 36.445 8.94065C36.4572 8.94692 36.4676 8.95605 36.4753 8.96726C36.4831 8.97847 36.4881 8.99142 36.4897 9.00497C36.4913 9.01851 36.4896 9.03226 36.4847 9.045L34.365 15.0789C34.2805 15.2984 34.361 15.5345 34.5971 15.5345H35.5974C35.7113 15.5344 35.8235 15.5054 35.9232 15.4502C36.0229 15.395 36.1069 15.3153 36.1674 15.2187L40.2789 9.07895C40.2867 9.067 40.2973 9.05723 40.3099 9.0506C40.3225 9.04396 40.3366 9.04067 40.3508 9.04105L43.0903 9.1129C43.2292 9.12158 43.7068 9.12553 43.8497 9.12553C45.72 9.12553 46.9018 8.52158 46.9018 7.77474C46.9018 7.02789 45.7239 6.41605 43.8497 6.41605Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var SvgIconFlyingOneWay = function SvgIconFlyingOneWay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 16,
    viewBox: "0 0 75 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFlyingOneWay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_flying_oneWay.eabd5a19.svg";
export { ForwardRef as ReactComponent };